import type { EducationContent } from '/index';

export default {
  topParas: [
    <>
      This category covers emissions from your business’s <strong>consumption of electricity, heat, and steam</strong>,
      along with any <strong>energy attribute certificates (EACs)</strong> applicable to the locations included within
      the boundaries of this carbon review.
    </>,
  ],
  exampleParas: [
    <>
      Emissions in this category include, for example, those from{' '}
      <strong>electricity used at your offices or warehouses</strong> to power lighting, IT equipment, heating, and
      cooling systems during the reporting period.
    </>,
  ],
  included: {
    points: [
      {
        hasBullet: true,
        title: <strong>Total kWh defined by certificate</strong>,
        paras: [
          {
            para: 'The total amount of energy (in kWh or MWh) specified in the energy attribute certificate, representing the volume purchased by your business.',
          },
        ],
      },
      {
        hasBullet: true,
        title: <strong>Remaining kWh available on certificate</strong>,
        paras: [
          {
            para: 'The remaining portion of the certificate’s total kWh or MWh that has not yet been allocated or used by your business.',
          },
        ],
      },
      {
        hasBullet: true,
        title: <strong>kWh allocation for this carbon review</strong>,
        paras: [
          {
            para: (
              <>
                The amount of kWh or MWh from the certificate that your business chooses to allocate to this carbon
                review. This amount must be <strong>equal to or less than</strong> the remaining kWh available on the
                certificate.
              </>
            ),
          },
        ],
      },
      {
        hasBullet: true,
        title: <strong>Supplier intensity data</strong>,
        paras: [
          {
            para: (
              <>
                Emission data provided directly by your energy supplier, typically expressed as{' '}
                <strong>carbon intensity per unit</strong> (e.g., kg CO₂e per kWh or per product unit).
              </>
            ),
          },
        ],
      },
      {
        hasBullet: true,
        title: <strong>Certificate validity period</strong>,
        paras: [
          {
            para: (
              <>
                The <strong>date range</strong> during which the energy attribute certificate is valid and can be
                applied to your energy consumption data.
              </>
            ),
          },
        ],
      },
    ],
  },
  notIncluded: {
    points: [
      {
        hasBullet: true,
        title: <strong>Locations</strong>,
        paras: [
          {
            para: (
              <>
                The physical <strong>sites and facilities</strong> your business occupies, either fully or partially,
                where energy consumption data is entered as part of this carbon review. These are detailed separately
                under the locations section.
              </>
            ),
          },
        ],
      },
      {
        hasBullet: true,
        title: <strong>Consumption data</strong>,
        paras: [
          {
            para: (
              <>
                Details on the <strong>type and amount of energy consumed</strong> (e.g., activity data or supplier
                intensity data), as well as any <strong>energy attribute certificates</strong> associated with each
                location, are covered separately under the consumption data section.
              </>
            ),
          },
        ],
      },
    ],
  },
} satisfies EducationContent;
